import(/* webpackMode: "eager" */ "/vercel/path0/src/app/experiences/page.tsx");
